export default {
  id: 48,
  title: 'Target #48 - Wash Your Hands',
  url: 'https://cssbattle.dev/play/48',
  colors: ['#293462', '#FE5F55', '#A64942'],
  solution:
    '<a a><a b><style>body{background:#293462}a{position:fixed}a[a]{top:90;left:100;width:200;height:100;background:#FE5F55;border-radius:20px;box-shadow:0 20px #A64942}a[b]{top:120;left:130;width:140;height:40;background:#A64942;border-radius:40px}</style>',
}
